import SoundOff from '@/features/Icons/SoundOff';
import SoundOn from '@/features/Icons/SoundOn';
import { useCallback } from 'react';
import './styles/soundToggle.scss';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';

import { setGameWindowContext } from '@/store/actions';
import { useStore } from '@/store/useStore';
import {
  SOUND_INTERACTION_TYPE,
  TRACK_USER_ACTION_EVENT,
  useTrackUserAction,
} from '@/utilities/logger/amplitude/tracking';

const SoundToggle = () => {
  const isAudioEnabled = useStore((s) => s.gameWindowContext.audioEnabled);

  const orientation = useAppOrientation();
  const { emitClientEvent } = useEventManagerEmitter();
  const { trackUserAction } = useTrackUserAction();

  const IconComponent = isAudioEnabled ? SoundOn : SoundOff;

  const handleSoundToggle = useCallback(() => {
    emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.TOGGLE_AUDIO, !isAudioEnabled);
    setGameWindowContext({
      audioEnabled: !isAudioEnabled,
    });
    trackUserAction({
      event: TRACK_USER_ACTION_EVENT.IN_GAME_SOUND_ADJUSTED,
      zone: 'DASHBOARD',
      interactionType: !isAudioEnabled
        ? SOUND_INTERACTION_TYPE.ON
        : SOUND_INTERACTION_TYPE.OFF,
    });
  }, [isAudioEnabled, emitClientEvent, trackUserAction]);
  return (
    <IconComponent
      onClick={handleSoundToggle}
      className={isAudioEnabled ? 'audio-on' : 'audio-off'}
      width={orientation === 'landscape' ? '30' : '27'}
      height={orientation === 'landscape' ? '22' : '20'}
    />
  );
};

export default SoundToggle;
